// #region arrayToCSV
// Helper to convert array of objects to CSV string for browser download
export function arrayToCSV(data: Array<Record<string, unknown>>): string {
  // Using this approach for simplicity and to avoid external CSV libraries
  if (!data.length) return "";
  const keys = Object.keys(data[0]);
  const escape = (val: unknown) => `"${String(val ?? "").replace(/"/g, '""')}"`; // Escape quotes for CSV
  const header = keys.map(escape).join(",");
  const rows = data.map((row) => keys.map((k) => escape(row[k])).join(","));
  return [header, ...rows].join("\r\n");
}
// #endregion arrayToCSV

// #region downloadCSV
// Helper to trigger browser download for a CSV file
export function downloadCSV(csv: string, filename: string) {
  // Using Blob and URL.createObjectURL for browser compatibility and simplicity
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
// #endregion downloadCSV
